<div *ngIf="activityCondition" class="moving" [ngClass]="{'sub-layer-active': store.state.common.determinantSection.topLayer === 'edit'}">
  <layer-header
    (closeLayer)="closeLayer()"
    [listIcons]="false"
    [title]="
      showDeterminantBuilder
        ? 'Condition - Determinant'
        : activityCondition.id
        ? 'Edit Condition'
        : 'Add Condition'
    "
  >
    <ng-content></ng-content>
  </layer-header>
  <determinant-new
    *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
    class="row layer sub-layer px-3 pt-1"
    [serviceId]="serviceId"
    [determinant]="store.state.common.determinantSection.determinant"
    (formSubmit)="closeDetLayer()"
    (editCancel)="closeDetLayer()"
  ></determinant-new>
  <div
    class="row {{
      store.state.common.determinantSection.topLayer === 'edit' ? 'hidden' : ''
    }}"
  >
    <div class="col-12">
      <form name="itemForm" role="form">
        <div class="row mb-4 fixie-buttons {{ showDeterminantBuilder ? '' : 'hidden' }}">
          <div class="col-12 mb-4">
            <primary-text-button (click)="submit()" [disabled]="isLoading">
              {{ 'Save' | translate }}
            </primary-text-button>
            <cancelary-text-button
              (click)="closeLayer()"
              [noRightMargin]="true"
            >
              {{ 'Cancel' | translate }}
            </cancelary-text-button>
          </div>
        </div>
        <div class="row mb-lg-3 {{ showDeterminantBuilder ? 'hidden' : '' }}">
          <div class="col-lg-12 col-md-12 mb-3 mb-lg-0">
            <label class="input-label field-required">{{
              'Condition Name' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              name="name"
              [(ngModel)]="activityCondition.name"
              #name="ngModel"
              [rangeLength]="[2, 256]"
              required
            />
            <p
              class="validation-error"
              *ngIf="name.errors?.required && (name?.dirty && name?.touched)"
            >
              {{ 'form.validate.required' | translate }}
            </p>
            <p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.minLenght' | translate }} 2!
            </p>
            <p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
              {{ 'form.validate.maxLenght' | translate }} 256!
            </p>
          </div>
        </div>
        <div class="row mb-lg-3 {{ showDeterminantBuilder ? 'hidden' : '' }}">
          <div class="col-lg-6 col-md-12 mb-3 mb-lg-0">
            <label class="input-label">{{
              'Legal Justification' | translate
            }}</label>
            <select
              class="form-control"
              name="law"
              [(ngModel)]="activityCondition.lawId"
              #law="ngModel"
              required
            >
              <option *ngFor="let law of laws" [ngValue]="law.id">{{
                law.name
              }}</option>
            </select>
          </div>
          <div class="col-lg-6 col-md-12 mb-3 mb-lg-0">
            <label class="input-label">{{
              'Paragraph or Article' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              name="paragraph"
              [(ngModel)]="activityCondition.paragraph"
              #paragraph="ngModel"
              [rangeLength]="[2, 256]"
              required
            />
          </div>
        </div>
        <div class="row mb-lg-3 {{ showDeterminantBuilder ? 'hidden' : '' }}">
          <div class="col-lg-12 col-md-12 mb-3 mb-lg-0">
            <label class="input-label">{{
              'Text of Paragraph' | translate
            }}</label>
            <textarea
              class="form-control"
              name="description"
              [(ngModel)]="activityCondition.description"
              rows="3"
              #description="ngModel"
              [rangeLength]="[2, 5000]"
            ></textarea>
            <p class="validation-error" *ngIf="description.errors?.rangeLength && (description?.dirty && description?.touched)">
              {{ 'form.validate.minLenght' | translate }} 2!
            </p>
            <p class="validation-error" *ngIf="description.errors?.rangeLength && (description?.dirty && description?.touched)">
              {{ 'form.validate.maxLenght' | translate }} 5000!
            </p>
          </div>
        </div>
        <div class="row mb-lg-3 {{ showDeterminantBuilder ? 'hidden' : '' }}">
          <div class="col-lg-6 col-md-12 mb-3 mb-lg-0">
            <label class="input-label">{{
              'Condition Type' | translate
            }}</label>
            <select
              class="form-control"
              name="activityConditionType"
              [(ngModel)]="activityCondition.typeId"
              #activityConditionType="ngModel"
            >
              <option
                *ngFor="let activityConditionType of activityConditionTypes"
                [ngValue]="activityConditionType.id"
                >{{ activityConditionType.name }}</option
              >
            </select>
          </div>
        </div>
        <div
          class="row no-gutters mb-0 {{
            showDeterminantBuilder ? '' : 'hidden'
          }}"
          *ngIf="
            registrationActivityCondition && registrationActivityCondition.id
          "
        >
          <div class="col-6 list-determinants">
            <determinant-list
                    [groupsLength]="{value: registrationActivityCondition.jsonDeterminants}"
                    [addDeterminantTo]="appendDeterminant"
                    [determinantMapById]="determinantMapById"
                    [prefix]="'ace'"></determinant-list>
          </div>
          <div class="col-6 px-3 query-builder">
            <query-builder *ngIf="determinantMapById != null" [determinantMapById]="determinantMapById"
                           [ngClass]="'fixed scrolleable'"
              [prefix]="'ace'"
              [jsonString]="registrationActivityCondition.jsonDeterminants"
              (onChange)="
                registrationActivityCondition.jsonDeterminants =
                  $event.jsonString
              "
            ></query-builder>
          </div>
        </div>
        <div class="row my-3 {{ showDeterminantBuilder ? 'hidden' : '' }}">
          <div class="col-12 mb-4">
            <primary-text-button
              (onClick)="submit()"
              [disabled]="isLoading || (name && name.invalid)"
            >
              {{ 'Save' | translate }}
            </primary-text-button>
            <cancelary-text-button (click)="closeLayer()">
              {{ 'Cancel' | translate }}
            </cancelary-text-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
